export default class ResponsiveSearch {
    constructor() {
        this.searchDiv = document.querySelector('.responsiveSearch');
        this.openButton = document.querySelector('.pageHeader__iconSearch');
        this.closeButton = document.querySelector('.responsiveSearch__close');
        this.open = false;
        this.bindEvents();
    }

    bindEvents() {
        this.openButton.addEventListener('click', (event) => this.openSearch(event));
        this.closeButton.addEventListener('click', (event) => this.closeSearch(event));
    }

    openSearch(event) {
        this.searchDiv.classList.add('isOpen');
    }

    closeSearch(event) {
        this.searchDiv.classList.remove('isOpen');
    }
}



// WEBPACK FOOTER //
// ./src/components/responsiveSearch/responsiveSearch.js